import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export default function Breadcrumbs({ items = [] }) {
  return (
    <nav
      aria-label="Ścieżka nawigacji"
      className="text-xs tracking-wide"
      data-testid="breadcrumbs"
    >
      <ol className="flex items-center gap-2 text-[var(--beautix-muted)] flex-wrap">
        <li className="flex items-center gap-2">
          <Link to="/" className="hover:text-[var(--beautix-pink)] flex items-center gap-1">
            <Home className="w-3 h-3" strokeWidth={1.5} />
            Start
          </Link>
        </li>
        {items.map((it, i) => (
          <li key={it.label} className="flex items-center gap-2">
            <ChevronRight className="w-3 h-3" strokeWidth={1.5} />
            {i === items.length - 1 || !it.to ? (
              <span className="text-[var(--beautix-ink)]">{it.label}</span>
            ) : (
              <Link to={it.to} className="hover:text-[var(--beautix-pink)]">
                {it.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
